export const DictionaryPhotoshop_en_US = [
    {
        id: 1,
        label: 'Photoshop > About Photoshop...',
        placement: 'MenuBar',
        name: 'About Photoshop...',
    },
    {
        id: 10,
        label: 'File > New...',
        placement: 'MenuBar',
        name: 'New...',
    },
    {
        id: 20,
        label: 'File > Open...',
        placement: 'MenuBar',
        name: 'Open...',
    },
    {
        id: 22,
        label: 'File > Open as Smart Object...',
        placement: 'MenuBar',
        name: 'Open as Smart Object...',
    },
    {
        id: 30,
        label: 'File > Save',
        placement: 'MenuBar',
        name: 'Save',
    },
    {
        id: 31,
        label: 'File > Close',
        placement: 'MenuBar',
        name: 'Close',
    },
    {
        id: 32,
        label: 'File > Save As...',
        placement: 'MenuBar',
        name: 'Save As...',
    },
    {
        id: 33,
        label: 'File > Save a Copy...',
        placement: 'MenuBar',
        name: 'Save a Copy...',
    },
    {
        id: 34,
        label: 'File > Revert',
        placement: 'MenuBar',
        name: 'Revert',
    },
    {
        id: 36,
        label: 'Photoshop > Quit Photoshop',
        placement: 'MenuBar',
        name: 'Quit Photoshop',
    },
    {
        id: 37,
        label: 'File > Close All',
        placement: 'MenuBar',
        name: 'Close All',
    },
    {
        id: 46,
        label: 'File > Close Others',
        placement: 'MenuBar',
        name: 'Close Others',
    },
    {
        id: 101,
        label: 'Edit > Undo',
        placement: 'MenuBar',
        name: 'Undo',
    },
    {
        id: 103,
        label: 'Edit > Cut',
        placement: 'MenuBar',
        name: 'Cut',
    },
    {
        id: 104,
        label: 'Edit > Copy',
        placement: 'MenuBar',
        name: 'Copy',
    },
    {
        id: 105,
        label: 'Edit > Paste',
        placement: 'MenuBar',
        name: 'Paste',
    },
    {
        id: 106,
        label: 'Edit > Clear',
        placement: 'MenuBar',
        name: 'Clear',
    },
    {
        id: 132,
        label: 'Edit > Redo',
        placement: 'MenuBar',
        name: 'Redo',
    },
    {
        id: 133,
        label: 'Edit > Toggle Last State',
        placement: 'MenuBar',
        name: 'Toggle Last State',
    },
    {
        id: 177,
        label: 'File > Print One Copy',
        placement: 'MenuBar',
        name: 'Print One Copy',
    },
    {
        id: 1001,
        label: 'Window > Arrange > New Window',
        placement: 'MenuBar',
        name: 'New Window',
    },
    {
        id: 1002,
        label: 'View > Rulers',
        placement: 'MenuBar',
        name: 'Rulers',
    },
    {
        id: 1004,
        label: 'View > Zoom In',
        placement: 'MenuBar',
        name: 'Zoom In',
    },
    {
        id: 1005,
        label: 'View > Zoom Out',
        placement: 'MenuBar',
        name: 'Zoom Out',
    },
    {
        id: 1006,
        label: 'Image > Mode > Bitmap',
        placement: 'MenuBar',
        name: 'Bitmap',
    },
    {
        id: 1007,
        label: 'Image > Mode > Grayscale',
        placement: 'MenuBar',
        name: 'Grayscale',
    },
    {
        id: 1008,
        label: 'Image > Mode > Duotone',
        placement: 'MenuBar',
        name: 'Duotone',
    },
    {
        id: 1009,
        label: 'Image > Mode > Indexed Color',
        placement: 'MenuBar',
        name: 'Indexed Color',
    },
    {
        id: 1010,
        label: 'Image > Mode > RGB Color',
        placement: 'MenuBar',
        name: 'RGB Color',
    },
    {
        id: 1011,
        label: 'Image > Mode > CMYK Color',
        placement: 'MenuBar',
        name: 'CMYK Color',
    },
    {
        id: 1014,
        label: 'Image > Mode > Multichannel',
        placement: 'MenuBar',
        name: 'Multichannel',
    },
    {
        id: 1016,
        label: 'Select > Deselect',
        placement: 'MenuBar',
        name: 'Deselect',
    },
    {
        id: 1017,
        label: 'Select > All',
        placement: 'MenuBar',
        name: 'All',
    },
    {
        id: 1018,
        label: 'Select > Inverse',
        placement: 'MenuBar',
        name: 'Inverse',
    },
    {
        id: 1019,
        label: 'Filter > Last Filter',
        placement: 'MenuBar',
        name: 'Last Filter',
    },
    {
        id: 1021,
        label: 'Window > Channels',
        placement: 'MenuBar',
        name: 'Channels',
    },
    {
        id: 1025,
        label: 'Window > Brush Settings',
        placement: 'MenuBar',
        name: 'Brush Settings',
    },
    {
        id: 1029,
        label: 'Edit > Define Brush Preset...',
        placement: 'MenuBar',
        name: 'Define Brush Preset...',
    },
    {
        id: 1030,
        label: 'Image > Image Size...',
        placement: 'MenuBar',
        name: 'Image Size...',
    },
    {
        id: 1031,
        label: 'Image > Canvas Size...',
        placement: 'MenuBar',
        name: 'Canvas Size...',
    },
    {
        id: 1032,
        label: 'File > Place Embedded...',
        placement: 'MenuBar',
        name: 'Place Embedded...',
    },
    {
        id: 1033,
        label: 'Select > Grow',
        placement: 'MenuBar',
        name: 'Grow',
    },
    {
        id: 1034,
        label: 'Select > Similar',
        placement: 'MenuBar',
        name: 'Similar',
    },
    {
        id: 1035,
        label: 'Select > Modify > Border...',
        placement: 'MenuBar',
        name: 'Border...',
    },
    {
        id: 1036,
        label: 'Select > Modify > Feather...',
        placement: 'MenuBar',
        name: 'Feather...',
    },
    {
        id: 1037,
        label: 'Layer > Matting > Defringe...',
        placement: 'MenuBar',
        name: 'Defringe...',
    },
    {
        id: 1038,
        label: 'Edit > Define Pattern...',
        placement: 'MenuBar',
        name: 'Define Pattern...',
    },
    {
        id: 1040,
        label: 'Edit > Paste Special > Paste Into',
        placement: 'MenuBar',
        name: 'Paste Into',
    },
    {
        id: 1042,
        label: 'Edit > Fill...',
        placement: 'MenuBar',
        name: 'Fill...',
    },
    {
        id: 1043,
        label: 'Edit > Stroke...',
        placement: 'MenuBar',
        name: 'Stroke...',
    },
    {
        id: 1044,
        label: 'Image > Crop',
        placement: 'MenuBar',
        name: 'Crop',
    },
    {
        id: 1045,
        label: 'Image > Mode > Color Table...',
        placement: 'MenuBar',
        name: 'Color Table...',
    },
    {
        id: 1046,
        label: 'Window > Color',
        placement: 'MenuBar',
        name: 'Color',
    },
    {
        id: 1052,
        label: 'Image > Mode > Lab Color',
        placement: 'MenuBar',
        name: 'Lab Color',
    },
    {
        id: 1055,
        label: 'Window > Info',
        placement: 'MenuBar',
        name: 'Info',
    },
    {
        id: 1058,
        label: 'Window > Clone Source',
        placement: 'MenuBar',
        name: 'Clone Source',
    },
    {
        id: 1065,
        label: 'Window > Paths',
        placement: 'MenuBar',
        name: 'Paths',
    },
    {
        id: 1080,
        label: 'Image > Trim...',
        placement: 'MenuBar',
        name: 'Trim...',
    },
    {
        id: 1081,
        label: 'Image > Reveal All',
        placement: 'MenuBar',
        name: 'Reveal All',
    },
    {
        id: 1093,
        label: 'Image > Trap...',
        placement: 'MenuBar',
        name: 'Trap...',
    },
    {
        id: 1098,
        label: 'Window > Layers',
        placement: 'MenuBar',
        name: 'Layers',
    },
    {
        id: 1099,
        label: 'Layer > New > Layer...',
        placement: 'MenuBar',
        name: 'Layer...',
    },
    {
        id: 1100,
        label: 'Layer > Delete > Layer',
        placement: 'MenuBar',
        name: 'Layer',
    },
    {
        id: 1103,
        label: 'Layer > Layer Content Options...',
        placement: 'MenuBar',
        name: 'Layer Content Options...',
    },
    {
        id: 1105,
        label: 'View > Proof Colors',
        placement: 'MenuBar',
        name: 'Proof Colors',
    },
    {
        id: 1106,
        label: 'View > Gamut Warning',
        placement: 'MenuBar',
        name: 'Gamut Warning',
    },
    {
        id: 1107,
        label: 'Edit > Copy Merged',
        placement: 'MenuBar',
        name: 'Copy Merged',
    },
    {
        id: 1108,
        label: 'Select > Modify > Smooth...',
        placement: 'MenuBar',
        name: 'Smooth...',
    },
    {
        id: 1109,
        label: 'Select > Modify > Expand...',
        placement: 'MenuBar',
        name: 'Expand...',
    },
    {
        id: 1110,
        label: 'Select > Modify > Contract...',
        placement: 'MenuBar',
        name: 'Contract...',
    },
    {
        id: 1111,
        label: 'Window > Options',
        placement: 'MenuBar',
        name: 'Options',
    },
    {
        id: 1112,
        label: 'View > Pixel Aspect Ratio Correction',
        placement: 'MenuBar',
        name: 'Pixel Aspect Ratio Correction',
    },
    {
        id: 1114,
        label: 'Layer > Hide Layers',
        placement: 'MenuBar',
        name: 'Hide Layers',
    },
    {
        id: 1115,
        label: 'Select > Select and Mask...',
        placement: 'MenuBar',
        name: 'Select and Mask...',
    },
    {
        id: 1119,
        label: 'Window > Swatches',
        placement: 'MenuBar',
        name: 'Swatches',
    },
    {
        id: 1134,
        label: 'Image > Duplicate...',
        placement: 'MenuBar',
        name: 'Duplicate...',
    },
    {
        id: 1135,
        label: 'Layer > Duplicate Layer...',
        placement: 'MenuBar',
        name: 'Duplicate Layer...',
    },
    {
        id: 1137,
        label: 'File > File Info...',
        placement: 'MenuBar',
        name: 'File Info...',
    },
    {
        id: 1139,
        label: 'Layer > Merge Visible',
        placement: 'MenuBar',
        name: 'Merge Visible',
    },
    {
        id: 1141,
        label: 'Layer > Flatten Image',
        placement: 'MenuBar',
        name: 'Flatten Image',
    },
    {
        id: 1152,
        label: 'Select > Color Range...',
        placement: 'MenuBar',
        name: 'Color Range...',
    },
    {
        id: 1153,
        label: 'Image > Apply Image...',
        placement: 'MenuBar',
        name: 'Apply Image...',
    },
    {
        id: 1154,
        label: 'Edit > Fade...',
        placement: 'MenuBar',
        name: 'Fade...',
    },
    {
        id: 1156,
        label: 'Layer > Layer Mask > Hide All',
        placement: 'MenuBar',
        name: 'Hide All',
    },
    {
        id: 1157,
        label: 'Layer > Layer Mask > Reveal All',
        placement: 'MenuBar',
        name: 'Reveal All',
    },
    {
        id: 1158,
        label: 'Layer > Layer Mask > Reveal Selection',
        placement: 'MenuBar',
        name: 'Reveal Selection',
    },
    {
        id: 1159,
        label: 'Layer > Layer Mask > Enable',
        placement: 'MenuBar',
        name: 'Enable',
    },
    {
        id: 1161,
        label: 'Image > Mode > 8 Bits/Channel',
        placement: 'MenuBar',
        name: '8 Bits/Channel',
    },
    {
        id: 1162,
        label: 'Image > Mode > 16 Bits/Channel',
        placement: 'MenuBar',
        name: '16 Bits/Channel',
    },
    {
        id: 1163,
        label: 'Window > Navigator',
        placement: 'MenuBar',
        name: 'Navigator',
    },
    {
        id: 1166,
        label: 'Layer > Merge Layers',
        placement: 'MenuBar',
        name: 'Merge Layers',
    },
    {
        id: 1167,
        label: 'Window > Layer Comps',
        placement: 'MenuBar',
        name: 'Layer Comps',
    },
    {
        id: 1168,
        label: 'Layer > Layer Mask > Hide Selection',
        placement: 'MenuBar',
        name: 'Hide Selection',
    },
    {
        id: 1169,
        label: 'File > Automate > Create Droplet...',
        placement: 'MenuBar',
        name: 'Create Droplet...',
    },
    {
        id: 1170,
        label: 'Window > Actions',
        placement: 'MenuBar',
        name: 'Actions',
    },
    {
        id: 1180,
        label: 'File > Automate > Batch...',
        placement: 'MenuBar',
        name: 'Batch...',
    },
    {
        id: 1188,
        label: 'Window > Timeline',
        placement: 'MenuBar',
        name: 'Timeline',
    },
    {
        id: 1190,
        label: 'View > 100%',
        placement: 'MenuBar',
        name: '100%',
    },
    {
        id: 1191,
        label: 'View > Print Size',
        placement: 'MenuBar',
        name: 'Print Size',
    },
    {
        id: 1192,
        label: 'View > Fit on Screen',
        placement: 'MenuBar',
        name: 'Fit on Screen',
    },
    {
        id: 1194,
        label: 'Window > Tools',
        placement: 'MenuBar',
        name: 'Tools',
    },
    {
        id: 1195,
        label: 'View > Fit Artboard on Screen',
        placement: 'MenuBar',
        name: 'Fit Artboard on Screen',
    },
    {
        id: 1199,
        label: 'Window > History',
        placement: 'MenuBar',
        name: 'History',
    },
    {
        id: 1200,
        label: 'Select > Load Selection...',
        placement: 'MenuBar',
        name: 'Load Selection...',
    },
    {
        id: 1202,
        label: 'View > Pixel Aspect Ratio > Custom Pixel Aspect Ratio...',
        placement: 'MenuBar',
        name: 'Custom Pixel Aspect Ratio...',
    },
    {
        id: 1203,
        label: 'View > Pixel Aspect Ratio > Delete Pixel Aspect Ratio...',
        placement: 'MenuBar',
        name: 'Delete Pixel Aspect Ratio...',
    },
    {
        id: 1204,
        label: 'View > Pixel Aspect Ratio > Reset Pixel Aspect Ratios...',
        placement: 'MenuBar',
        name: 'Reset Pixel Aspect Ratios...',
    },
    {
        id: 1205,
        label: 'View > Pixel Aspect Ratio > Square',
        placement: 'MenuBar',
        name: 'Square',
    },
    {
        id: 1206,
        label: 'Image > Mode > 32 Bits/Channel',
        placement: 'MenuBar',
        name: '32 Bits/Channel',
    },
    {
        id: 1211,
        label: 'Edit > Presets > Migrate Presets',
        placement: 'MenuBar',
        name: 'Migrate Presets',
    },
    {
        id: 1212,
        label: 'Edit > Assign Profile...',
        placement: 'MenuBar',
        name: 'Assign Profile...',
    },
    {
        id: 1213,
        label: 'Edit > Convert to Profile...',
        placement: 'MenuBar',
        name: 'Convert to Profile...',
    },
    {
        id: 1214,
        label: 'Edit > Presets > Preset Manager...',
        placement: 'MenuBar',
        name: 'Preset Manager...',
    },
    {
        id: 1215,
        label: 'Edit > Adobe PDF Presets...',
        placement: 'MenuBar',
        name: 'Adobe PDF Presets...',
    },
    {
        id: 1217,
        label: 'View > Actual Size',
        placement: 'MenuBar',
        name: 'Actual Size',
    },
    {
        id: 1223,
        label: 'Type > Orientation > Horizontal',
        placement: 'MenuBar',
        name: 'Horizontal',
    },
    {
        id: 1224,
        label: 'Type > Orientation > Vertical',
        placement: 'MenuBar',
        name: 'Vertical',
    },
    {
        id: 1228,
        label: 'Type > Create Work Path',
        placement: 'MenuBar',
        name: 'Create Work Path',
    },
    {
        id: 1229,
        label: 'Type > Convert to Shape',
        placement: 'MenuBar',
        name: 'Convert to Shape',
    },
    {
        id: 1231,
        label: 'Layer > Align > Top Edges',
        placement: 'MenuBar',
        name: 'Top Edges',
    },
    {
        id: 1232,
        label: 'Layer > Align > Bottom Edges',
        placement: 'MenuBar',
        name: 'Bottom Edges',
    },
    {
        id: 1233,
        label: 'Layer > Align > Vertical Centers',
        placement: 'MenuBar',
        name: 'Vertical Centers',
    },
    {
        id: 1234,
        label: 'Layer > Align > Left Edges',
        placement: 'MenuBar',
        name: 'Left Edges',
    },
    {
        id: 1235,
        label: 'Layer > Align > Right Edges',
        placement: 'MenuBar',
        name: 'Right Edges',
    },
    {
        id: 1236,
        label: 'Layer > Align > Horizontal Centers',
        placement: 'MenuBar',
        name: 'Horizontal Centers',
    },
    {
        id: 1237,
        label: 'Edit > Auto-Align Layers...',
        placement: 'MenuBar',
        name: 'Auto-Align Layers...',
    },
    {
        id: 1238,
        label: 'Edit > Auto-Blend Layers...',
        placement: 'MenuBar',
        name: 'Auto-Blend Layers...',
    },
    {
        id: 1239,
        label: 'Layer > Distribute > Vertically',
        placement: 'MenuBar',
        name: 'Vertically',
    },
    {
        id: 1241,
        label: 'Layer > Distribute > Top Edges',
        placement: 'MenuBar',
        name: 'Top Edges',
    },
    {
        id: 1242,
        label: 'Layer > Distribute > Bottom Edges',
        placement: 'MenuBar',
        name: 'Bottom Edges',
    },
    {
        id: 1243,
        label: 'Layer > Distribute > Vertical Centers',
        placement: 'MenuBar',
        name: 'Vertical Centers',
    },
    {
        id: 1245,
        label: 'Layer > Distribute > Left Edges',
        placement: 'MenuBar',
        name: 'Left Edges',
    },
    {
        id: 1246,
        label: 'Layer > Distribute > Right Edges',
        placement: 'MenuBar',
        name: 'Right Edges',
    },
    {
        id: 1247,
        label: 'Layer > Distribute > Horizontal Centers',
        placement: 'MenuBar',
        name: 'Horizontal Centers',
    },
    {
        id: 1249,
        label: 'Layer > Distribute > Horizontally',
        placement: 'MenuBar',
        name: 'Horizontally',
    },
    {
        id: 1281,
        label: 'Select > Save Selection...',
        placement: 'MenuBar',
        name: 'Save Selection...',
    },
    {
        id: 1284,
        label: 'View > Flip Horizontal',
        placement: 'MenuBar',
        name: 'Flip Horizontal',
    },
    {
        id: 1285,
        label: 'View > Pattern Preview',
        placement: 'MenuBar',
        name: 'Pattern Preview',
    },
    {
        id: 1292,
        label: 'Layer > Layer Mask > From Transparency',
        placement: 'MenuBar',
        name: 'From Transparency',
    },
    {
        id: 1295,
        label: 'Layer > Matting > Color Decontaminate...',
        placement: 'MenuBar',
        name: 'Color Decontaminate...',
    },
    {
        id: 1297,
        label: 'Edit > Paste Special > Paste in Place',
        placement: 'MenuBar',
        name: 'Paste in Place',
    },
    {
        id: 1299,
        label: 'View > 200%',
        placement: 'MenuBar',
        name: '200%',
    },
    {
        id: 1301,
        label: 'Layer > Layer Style > Drop Shadow...',
        placement: 'MenuBar',
        name: 'Drop Shadow...',
    },
    {
        id: 1302,
        label: 'Layer > Layer Style > Inner Shadow...',
        placement: 'MenuBar',
        name: 'Inner Shadow...',
    },
    {
        id: 1303,
        label: 'Layer > Layer Style > Outer Glow...',
        placement: 'MenuBar',
        name: 'Outer Glow...',
    },
    {
        id: 1304,
        label: 'Layer > Layer Style > Inner Glow...',
        placement: 'MenuBar',
        name: 'Inner Glow...',
    },
    {
        id: 1305,
        label: 'Layer > Layer Style > Bevel & Emboss...',
        placement: 'MenuBar',
        name: 'Bevel & Emboss...',
    },
    {
        id: 1306,
        label: 'Layer > Layer Style > Hide All Effects',
        placement: 'MenuBar',
        name: 'Hide All Effects',
    },
    {
        id: 1307,
        label: 'Layer > Layer Style > Global Light...',
        placement: 'MenuBar',
        name: 'Global Light...',
    },
    {
        id: 1308,
        label: 'Layer > Layer Style > Create Layers',
        placement: 'MenuBar',
        name: 'Create Layers',
    },
    {
        id: 1312,
        label: 'Layer > Layer Style > Satin...',
        placement: 'MenuBar',
        name: 'Satin...',
    },
    {
        id: 1313,
        label: 'Layer > Layer Style > Stroke...',
        placement: 'MenuBar',
        name: 'Stroke...',
    },
    {
        id: 1314,
        label: 'Layer > Layer Style > Copy Layer Style',
        placement: 'MenuBar',
        name: 'Copy Layer Style',
    },
    {
        id: 1315,
        label: 'Layer > Layer Style > Paste Layer Style',
        placement: 'MenuBar',
        name: 'Paste Layer Style',
    },
    {
        id: 1327,
        label: 'Layer > Layer Style > Scale Effects...',
        placement: 'MenuBar',
        name: 'Scale Effects...',
    },
    {
        id: 1331,
        label: 'Layer > Layer Style > Blending Options...',
        placement: 'MenuBar',
        name: 'Blending Options...',
    },
    {
        id: 1335,
        label: 'Layer > Layer Style > Color Overlay...',
        placement: 'MenuBar',
        name: 'Color Overlay...',
    },
    {
        id: 1336,
        label: 'Layer > Layer Style > Gradient Overlay...',
        placement: 'MenuBar',
        name: 'Gradient Overlay...',
    },
    {
        id: 1337,
        label: 'Layer > Layer Style > Pattern Overlay...',
        placement: 'MenuBar',
        name: 'Pattern Overlay...',
    },
    {
        id: 1339,
        label: 'Layer > Layer Style > Clear Layer Style',
        placement: 'MenuBar',
        name: 'Clear Layer Style',
    },
    {
        id: 1355,
        label: 'Window > Notes',
        placement: 'MenuBar',
        name: 'Notes',
    },
    {
        id: 1382,
        label: 'Window > Histogram',
        placement: 'MenuBar',
        name: 'Histogram',
    },
    {
        id: 1396,
        label: 'Window > Brushes',
        placement: 'MenuBar',
        name: 'Brushes',
    },
    {
        id: 1429,
        label: 'Plugins > Plugins Panel',
        placement: 'MenuBar',
        name: 'Plugins Panel',
    },
    {
        id: 1430,
        label: 'Plugins > Browse Plugins...',
        placement: 'MenuBar',
        name: 'Browse Plugins...',
    },
    {
        id: 1431,
        label: 'Plugins > Manage Plugins...',
        placement: 'MenuBar',
        name: 'Manage Plugins...',
    },
    {
        id: 1460,
        label: 'Select > Focus Area...',
        placement: 'MenuBar',
        name: 'Focus Area...',
    },
    {
        id: 1461,
        label: 'Select > Subject',
        placement: 'MenuBar',
        name: 'Subject',
    },
    {
        id: 1462,
        label: 'Select > Sky',
        placement: 'MenuBar',
        name: 'Sky',
    },
    {
        id: 1502,
        label: 'File > Import > Images from Device...',
        placement: 'MenuBar',
        name: 'Images from Device...',
    },
    {
        id: 1503,
        label: 'File > Import from iPhone or iPad',
        placement: 'MenuBar',
        name: 'Import from iPhone or iPad',
    },
    {
        id: 1510,
        label: 'Edit > Content-Aware Fill...',
        placement: 'MenuBar',
        name: 'Content-Aware Fill...',
    },
    {
        id: 1520,
        label: 'File > Browse in Bridge...',
        placement: 'MenuBar',
        name: 'Browse in Bridge...',
    },
    {
        id: 1522,
        label: 'Type > More from Adobe Fonts...',
        placement: 'MenuBar',
        name: 'More from Adobe Fonts...',
    },
    {
        id: 1530,
        label: 'File > Close and Go to Bridge...',
        placement: 'MenuBar',
        name: 'Close and Go to Bridge...',
    },
    {
        id: 1613,
        label: 'Edit > Remote Connections...',
        placement: 'MenuBar',
        name: 'Remote Connections...',
    },
    {
        id: 1676,
        label: 'File > Scripts > Browse...',
        placement: 'MenuBar',
        name: 'Browse...',
    },
    {
        id: 1695,
        label: 'File > Export > Save for Web...',
        placement: 'MenuBar',
        name: 'Save for Web...',
    },
    {
        id: 1696,
        label: 'File > Automate > PDF Presentation...',
        placement: 'MenuBar',
        name: 'PDF Presentation...',
    },
    {
        id: 1701,
        label: 'Image > Adjustments > Invert',
        placement: 'MenuBar',
        name: 'Invert',
    },
    {
        id: 1702,
        label: 'Image > Adjustments > Equalize',
        placement: 'MenuBar',
        name: 'Equalize',
    },
    {
        id: 1703,
        label: 'Image > Adjustments > Threshold...',
        placement: 'MenuBar',
        name: 'Threshold...',
    },
    {
        id: 1704,
        label: 'Image > Adjustments > Posterize...',
        placement: 'MenuBar',
        name: 'Posterize...',
    },
    {
        id: 1750,
        label: 'Edit > Generative Fill...',
        placement: 'MenuBar',
        name: 'Generative Fill...',
    },
    {
        id: 1771,
        label: 'Edit > Generate Image...',
        placement: 'MenuBar',
        name: 'Generate Image...',
    },
    {
        id: 1776,
        label: 'Image > Generative Upscale...',
        placement: 'MenuBar',
        name: 'Generative Upscale...',
    },
    {
        id: 1777,
        label: 'Filter > AI Denoise...',
        placement: 'MenuBar',
        name: 'AI Denoise...',
    },
    {
        id: 1778,
        label: 'Filter > AI Sharpen...',
        placement: 'MenuBar',
        name: 'AI Sharpen...',
    },
    {
        id: 1801,
        label: 'Image > Adjustments > Levels...',
        placement: 'MenuBar',
        name: 'Levels...',
    },
    {
        id: 1802,
        label: 'Image > Adjustments > Curves...',
        placement: 'MenuBar',
        name: 'Curves...',
    },
    {
        id: 1803,
        label: 'Image > Adjustments > Brightness/Contrast...',
        placement: 'MenuBar',
        name: 'Brightness/Contrast...',
    },
    {
        id: 1804,
        label: 'Image > Adjustments > Color Balance...',
        placement: 'MenuBar',
        name: 'Color Balance...',
    },
    {
        id: 1805,
        label: 'Image > Adjustments > Hue/Saturation...',
        placement: 'MenuBar',
        name: 'Hue/Saturation...',
    },
    {
        id: 1806,
        label: 'Image > Adjustments > Replace Color...',
        placement: 'MenuBar',
        name: 'Replace Color...',
    },
    {
        id: 1807,
        label: 'Image > Adjustments > Selective Color...',
        placement: 'MenuBar',
        name: 'Selective Color...',
    },
    {
        id: 1808,
        label: 'Image > Auto Tone',
        placement: 'MenuBar',
        name: 'Auto Tone',
    },
    {
        id: 1809,
        label: 'Image > Adjustments > Desaturate',
        placement: 'MenuBar',
        name: 'Desaturate',
    },
    {
        id: 1810,
        label: 'Image > Auto Contrast',
        placement: 'MenuBar',
        name: 'Auto Contrast',
    },
    {
        id: 1817,
        label: 'Image > Auto Color',
        placement: 'MenuBar',
        name: 'Auto Color',
    },
    {
        id: 1822,
        label: 'Image > Adjustments > Match Color...',
        placement: 'MenuBar',
        name: 'Match Color...',
    },
    {
        id: 1824,
        label: 'Image > Adjustments > Black & White...',
        placement: 'MenuBar',
        name: 'Black & White...',
    },
    {
        id: 1827,
        label: 'Image > Adjustments > Vibrance...',
        placement: 'MenuBar',
        name: 'Vibrance...',
    },
    {
        id: 1900,
        label: 'Image > Calculations...',
        placement: 'MenuBar',
        name: 'Calculations...',
    },
    {
        id: 1942,
        label: 'Layer > New > Background',
        placement: 'MenuBar',
        name: 'Background',
    },
    {
        id: 1943,
        label: 'Select > Reselect',
        placement: 'MenuBar',
        name: 'Reselect',
    },
    {
        id: 1953,
        label: 'Layer > Vector Mask > Hide All',
        placement: 'MenuBar',
        name: 'Hide All',
    },
    {
        id: 1954,
        label: 'Layer > Vector Mask > Reveal All',
        placement: 'MenuBar',
        name: 'Reveal All',
    },
    {
        id: 1955,
        label: 'Layer > Vector Mask > Current Path',
        placement: 'MenuBar',
        name: 'Current Path',
    },
    {
        id: 1956,
        label: 'Layer > Vector Mask > Delete',
        placement: 'MenuBar',
        name: 'Delete',
    },
    {
        id: 1957,
        label: 'Layer > Rasterize > Vector Mask',
        placement: 'MenuBar',
        name: 'Vector Mask',
    },
    {
        id: 1959,
        label: 'Layer > Vector Mask > Enable',
        placement: 'MenuBar',
        name: 'Enable',
    },
    {
        id: 1971,
        label: 'Select > Transform Selection',
        placement: 'MenuBar',
        name: 'Transform Selection',
    },
    {
        id: 2101,
        label: 'File > Print...',
        placement: 'MenuBar',
        name: 'Print...',
    },
    {
        id: 2103,
        label: 'File > Open Recent > Clear Recent File List',
        placement: 'MenuBar',
        name: 'Clear Recent File List',
    },
    {
        id: 2109,
        label: 'Layer > Vector Mask > Link',
        placement: 'MenuBar',
        name: 'Link',
    },
    {
        id: 2201,
        label: 'Edit > Transform > Scale',
        placement: 'MenuBar',
        name: 'Scale',
    },
    {
        id: 2202,
        label: 'Edit > Transform > Skew',
        placement: 'MenuBar',
        name: 'Skew',
    },
    {
        id: 2203,
        label: 'Edit > Transform > Perspective',
        placement: 'MenuBar',
        name: 'Perspective',
    },
    {
        id: 2204,
        label: 'Edit > Transform > Distort',
        placement: 'MenuBar',
        name: 'Distort',
    },
    {
        id: 2205,
        label: 'Edit > Transform > Rotate',
        placement: 'MenuBar',
        name: 'Rotate',
    },
    {
        id: 2207,
        label: 'Edit > Free Transform',
        placement: 'MenuBar',
        name: 'Free Transform',
    },
    {
        id: 2208,
        label: 'Edit > Transform > Rotate 180°',
        placement: 'MenuBar',
        name: 'Rotate 180°',
    },
    {
        id: 2209,
        label: 'Edit > Transform > Rotate 90° Clockwise',
        placement: 'MenuBar',
        name: 'Rotate 90° Clockwise',
    },
    {
        id: 2210,
        label: 'Edit > Transform > Rotate 90° Counter Clockwise',
        placement: 'MenuBar',
        name: 'Rotate 90° Counter Clockwise',
    },
    {
        id: 2211,
        label: 'Edit > Transform > Flip Horizontal',
        placement: 'MenuBar',
        name: 'Flip Horizontal',
    },
    {
        id: 2212,
        label: 'Edit > Transform > Flip Vertical',
        placement: 'MenuBar',
        name: 'Flip Vertical',
    },
    {
        id: 2217,
        label: 'Edit > Transform > Again',
        placement: 'MenuBar',
        name: 'Again',
    },
    {
        id: 2218,
        label: 'Type > Warp Text...',
        placement: 'MenuBar',
        name: 'Warp Text...',
    },
    {
        id: 2219,
        label: 'Edit > Transform > Warp',
        placement: 'MenuBar',
        name: 'Warp',
    },
    {
        id: 2220,
        label: 'Edit > Content-Aware Scale',
        placement: 'MenuBar',
        name: 'Content-Aware Scale',
    },
    {
        id: 2221,
        label: 'Edit > Puppet Warp',
        placement: 'MenuBar',
        name: 'Puppet Warp',
    },
    {
        id: 2224,
        label: 'Filter > Blur Gallery > Iris Blur...',
        placement: 'MenuBar',
        name: 'Iris Blur...',
    },
    {
        id: 2225,
        label: 'Filter > Blur Gallery > Field Blur...',
        placement: 'MenuBar',
        name: 'Field Blur...',
    },
    {
        id: 2226,
        label: 'Filter > Blur Gallery > Tilt-Shift...',
        placement: 'MenuBar',
        name: 'Tilt-Shift...',
    },
    {
        id: 2227,
        label: 'Filter > Blur Gallery > Path Blur...',
        placement: 'MenuBar',
        name: 'Path Blur...',
    },
    {
        id: 2229,
        label: 'Filter > Blur Gallery > Spin Blur...',
        placement: 'MenuBar',
        name: 'Spin Blur...',
    },
    {
        id: 2231,
        label: 'Filter > Render > Flame...',
        placement: 'MenuBar',
        name: 'Flame...',
    },
    {
        id: 2232,
        label: 'Filter > Render > Picture Frame...',
        placement: 'MenuBar',
        name: 'Picture Frame...',
    },
    {
        id: 2233,
        label: 'Filter > Render > Tree...',
        placement: 'MenuBar',
        name: 'Tree...',
    },
    {
        id: 2250,
        label: 'Edit > Transform > Split Warp Horizontally',
        placement: 'MenuBar',
        name: 'Split Warp Horizontally',
    },
    {
        id: 2251,
        label: 'Edit > Transform > Split Warp Vertically',
        placement: 'MenuBar',
        name: 'Split Warp Vertically',
    },
    {
        id: 2252,
        label: 'Edit > Transform > Split Warp Crosswise',
        placement: 'MenuBar',
        name: 'Split Warp Crosswise',
    },
    {
        id: 2253,
        label: 'Edit > Transform > Remove Warp Split',
        placement: 'MenuBar',
        name: 'Remove Warp Split',
    },
    {
        id: 2254,
        label: 'Edit > Transform > Toggle Guides',
        placement: 'MenuBar',
        name: 'Toggle Guides',
    },
    {
        id: 2255,
        label: 'Edit > Transform > Convert warp anchor point',
        placement: 'MenuBar',
        name: 'Convert warp anchor point',
    },
    {
        id: 2260,
        label: 'Edit > Sky Replacement...',
        placement: 'MenuBar',
        name: 'Sky Replacement...',
    },
    {
        id: 2304,
        label: 'Photoshop > Preferences > Performance...',
        placement: 'MenuBar',
        name: 'Performance...',
    },
    {
        id: 2311,
        label: 'Photoshop > Preferences > General...',
        placement: 'MenuBar',
        name: 'General...',
    },
    {
        id: 2312,
        label: 'Photoshop > Preferences > Cursors...',
        placement: 'MenuBar',
        name: 'Cursors...',
    },
    {
        id: 2313,
        label: 'Photoshop > Preferences > Transparency & Gamut...',
        placement: 'MenuBar',
        name: 'Transparency & Gamut...',
    },
    {
        id: 2314,
        label: 'Photoshop > Preferences > Units & Rulers...',
        placement: 'MenuBar',
        name: 'Units & Rulers...',
    },
    {
        id: 2315,
        label: 'Photoshop > Preferences > Guides, Grid & Slices...',
        placement: 'MenuBar',
        name: 'Guides, Grid & Slices...',
    },
    {
        id: 2316,
        label: 'Photoshop > Preferences > Plugins...',
        placement: 'MenuBar',
        name: 'Plugins...',
    },
    {
        id: 2317,
        label: 'Photoshop > Preferences > File Handling...',
        placement: 'MenuBar',
        name: 'File Handling...',
    },
    {
        id: 2322,
        label: 'Photoshop > Preferences > Type...',
        placement: 'MenuBar',
        name: 'Type...',
    },
    {
        id: 2323,
        label: 'Photoshop > Preferences > Interface...',
        placement: 'MenuBar',
        name: 'Interface...',
    },
    {
        id: 2324,
        label: 'Photoshop > Preferences > Camera Raw...',
        placement: 'MenuBar',
        name: 'Camera Raw...',
    },
    {
        id: 2327,
        label: 'Photoshop > Preferences > Technology Previews...',
        placement: 'MenuBar',
        name: 'Technology Previews...',
    },
    {
        id: 2328,
        label: 'Photoshop > Preferences > Scratch Disks...',
        placement: 'MenuBar',
        name: 'Scratch Disks...',
    },
    {
        id: 2329,
        label: 'Photoshop > Preferences > History & Content Credentials...',
        placement: 'MenuBar',
        name: 'History & Content Credentials...',
    },
    {
        id: 2330,
        label: 'Photoshop > Preferences > Tools...',
        placement: 'MenuBar',
        name: 'Tools...',
    },
    {
        id: 2331,
        label: 'Photoshop > Preferences > Workspace...',
        placement: 'MenuBar',
        name: 'Workspace...',
    },
    {
        id: 2332,
        label: 'Photoshop > Preferences > Export...',
        placement: 'MenuBar',
        name: 'Export...',
    },
    {
        id: 2332,
        label: 'File > Export > Export Preferences...',
        placement: 'MenuBar',
        name: 'Export Preferences...',
    },
    {
        id: 2333,
        label: 'Photoshop > Preferences > Enhanced Controls...',
        placement: 'MenuBar',
        name: 'Enhanced Controls...',
    },
    {
        id: 2335,
        label: 'Photoshop > Preferences > Image Processing...',
        placement: 'MenuBar',
        name: 'Image Processing...',
    },
    {
        id: 2337,
        label: 'Photoshop > Preferences > Notifications...',
        placement: 'MenuBar',
        name: 'Notifications...',
    },
    {
        id: 2344,
        label: 'Edit > Color Settings...',
        placement: 'MenuBar',
        name: 'Color Settings...',
    },
    {
        id: 2345,
        label: 'Edit > OpenColorIO Settings...',
        placement: 'MenuBar',
        name: 'OpenColorIO Settings...',
    },
    {
        id: 2361,
        label: 'Edit > Purge > Histories',
        placement: 'MenuBar',
        name: 'Histories',
    },
    {
        id: 2701,
        label: 'Layer > Matting > Remove Black Matte',
        placement: 'MenuBar',
        name: 'Remove Black Matte',
    },
    {
        id: 2703,
        label: 'Layer > Matting > Remove White Matte',
        placement: 'MenuBar',
        name: 'Remove White Matte',
    },
    {
        id: 2711,
        label: 'Layer > Arrange > Bring to Front',
        placement: 'MenuBar',
        name: 'Bring to Front',
    },
    {
        id: 2712,
        label: 'Layer > Arrange > Bring Forward',
        placement: 'MenuBar',
        name: 'Bring Forward',
    },
    {
        id: 2713,
        label: 'Layer > Arrange > Send Backward',
        placement: 'MenuBar',
        name: 'Send Backward',
    },
    {
        id: 2714,
        label: 'Layer > Arrange > Send to Back',
        placement: 'MenuBar',
        name: 'Send to Back',
    },
    {
        id: 2715,
        label: 'Layer > Arrange > Reverse',
        placement: 'MenuBar',
        name: 'Reverse',
    },
    {
        id: 2769,
        label: 'Layer > Smart Filter > Disable Smart Filters',
        placement: 'MenuBar',
        name: 'Disable Smart Filters',
    },
    {
        id: 2770,
        label: 'Layer > Smart Filter > Clear Smart Filters',
        placement: 'MenuBar',
        name: 'Clear Smart Filters',
    },
    {
        id: 2802,
        label: 'View > Proof Setup > Custom...',
        placement: 'MenuBar',
        name: 'Custom...',
    },
    {
        id: 2803,
        label: 'View > Proof Setup > Working CMYK',
        placement: 'MenuBar',
        name: 'Working CMYK',
    },
    {
        id: 2804,
        label: 'View > Proof Setup > Working Cyan Plate',
        placement: 'MenuBar',
        name: 'Working Cyan Plate',
    },
    {
        id: 2805,
        label: 'View > Proof Setup > Working Magenta Plate',
        placement: 'MenuBar',
        name: 'Working Magenta Plate',
    },
    {
        id: 2806,
        label: 'View > Proof Setup > Working Yellow Plate',
        placement: 'MenuBar',
        name: 'Working Yellow Plate',
    },
    {
        id: 2807,
        label: 'View > Proof Setup > Working Black Plate',
        placement: 'MenuBar',
        name: 'Working Black Plate',
    },
    {
        id: 2808,
        label: 'View > Proof Setup > Working CMY Plates',
        placement: 'MenuBar',
        name: 'Working CMY Plates',
    },
    {
        id: 2809,
        label: 'View > Proof Setup > Legacy Macintosh RGB (Gamma 1.8)',
        placement: 'MenuBar',
        name: 'Legacy Macintosh RGB (Gamma 1.8)',
    },
    {
        id: 2810,
        label: 'View > Proof Setup > Internet Standard RGB (sRGB)',
        placement: 'MenuBar',
        name: 'Internet Standard RGB (sRGB)',
    },
    {
        id: 2811,
        label: 'View > Proof Setup > Monitor RGB',
        placement: 'MenuBar',
        name: 'Monitor RGB',
    },
    {
        id: 2815,
        label: 'View > Proof Setup > Color Blindness - Protanopia-type',
        placement: 'MenuBar',
        name: 'Color Blindness - Protanopia-type',
    },
    {
        id: 2816,
        label: 'View > Proof Setup > Color Blindness - Deuteranopia-type',
        placement: 'MenuBar',
        name: 'Color Blindness - Deuteranopia-type',
    },
    {
        id: 2820,
        label: 'Image > Analysis > Ruler Tool',
        placement: 'MenuBar',
        name: 'Ruler Tool',
    },
    {
        id: 2830,
        label: 'Image > Analysis > Place Scale Marker...',
        placement: 'MenuBar',
        name: 'Place Scale Marker...',
    },
    {
        id: 2841,
        label: 'Image > Analysis > Set Measurement Scale > Default',
        placement: 'MenuBar',
        name: 'Default',
    },
    {
        id: 2842,
        label: 'Image > Analysis > Set Measurement Scale > Custom...',
        placement: 'MenuBar',
        name: 'Custom...',
    },
    {
        id: 2851,
        label: 'Image > Analysis > Select Data Points > Custom...',
        placement: 'MenuBar',
        name: 'Custom...',
    },
    {
        id: 2860,
        label: 'Image > Analysis > Record Measurements',
        placement: 'MenuBar',
        name: 'Record Measurements',
    },
    {
        id: 2880,
        label: 'Window > Measurement Log',
        placement: 'MenuBar',
        name: 'Measurement Log',
    },
    {
        id: 2912,
        label: 'Edit > Purge > Clipboard',
        placement: 'MenuBar',
        name: 'Clipboard',
    },
    {
        id: 2915,
        label: 'Edit > Purge > All',
        placement: 'MenuBar',
        name: 'All',
    },
    {
        id: 2920,
        label: 'Edit > Purge > Video Cache',
        placement: 'MenuBar',
        name: 'Video Cache',
    },
    {
        id: 2939,
        label: 'Window > Workspace > Lock Workspace',
        placement: 'MenuBar',
        name: 'Lock Workspace',
    },
    {
        id: 2940,
        label: 'View > Guides > Lock Guides',
        placement: 'MenuBar',
        name: 'Lock Guides',
    },
    {
        id: 2950,
        label: 'View > Guides > Clear Guides',
        placement: 'MenuBar',
        name: 'Clear Guides',
    },
    {
        id: 2951,
        label: 'Layer > Delete > Hidden Layers',
        placement: 'MenuBar',
        name: 'Hidden Layers',
    },
    {
        id: 2952,
        label: 'View > Guides > Clear Selected Artboard Guides',
        placement: 'MenuBar',
        name: 'Clear Selected Artboard Guides',
    },
    {
        id: 2953,
        label: 'View > Guides > Clear Canvas Guides',
        placement: 'MenuBar',
        name: 'Clear Canvas Guides',
    },
    {
        id: 2956,
        label: 'Layer > New > Group from Layers...',
        placement: 'MenuBar',
        name: 'Group from Layers...',
    },
    {
        id: 2957,
        label: 'Layer > Lock Layers...',
        placement: 'MenuBar',
        name: 'Lock Layers...',
    },
    {
        id: 2958,
        label: 'Layer > Group Layers',
        placement: 'MenuBar',
        name: 'Group Layers',
    },
    {
        id: 2959,
        label: 'Layer > Ungroup Layers',
        placement: 'MenuBar',
        name: 'Ungroup Layers',
    },
    {
        id: 2960,
        label: 'Layer > Select Linked Layers',
        placement: 'MenuBar',
        name: 'Select Linked Layers',
    },
    {
        id: 2961,
        label: 'Layer > Link Layers',
        placement: 'MenuBar',
        name: 'Link Layers',
    },
    {
        id: 2962,
        label: 'Select > All Layers',
        placement: 'MenuBar',
        name: 'All Layers',
    },
    {
        id: 2963,
        label: 'Select > Deselect Layers',
        placement: 'MenuBar',
        name: 'Deselect Layers',
    },
    {
        id: 2967,
        label: 'View > Lock Slices',
        placement: 'MenuBar',
        name: 'Lock Slices',
    },
    {
        id: 2969,
        label: 'View > Clear Slices',
        placement: 'MenuBar',
        name: 'Clear Slices',
    },
    {
        id: 2970,
        label: 'Layer > New > Layer via Copy',
        placement: 'MenuBar',
        name: 'Layer via Copy',
    },
    {
        id: 2971,
        label: 'Layer > New > Layer via Cut',
        placement: 'MenuBar',
        name: 'Layer via Cut',
    },
    {
        id: 2972,
        label: 'Layer > Create Clipping Mask',
        placement: 'MenuBar',
        name: 'Create Clipping Mask',
    },
    {
        id: 2976,
        label: 'Layer > New > Group...',
        placement: 'MenuBar',
        name: 'Group...',
    },
    {
        id: 2980,
        label: 'Layer > Smart Objects > Convert to Smart Object',
        placement: 'MenuBar',
        name: 'Convert to Smart Object',
    },
    {
        id: 2981,
        label: 'Layer > Smart Objects > New Smart Object via Copy',
        placement: 'MenuBar',
        name: 'New Smart Object via Copy',
    },
    {
        id: 2982,
        label: 'Select > Find Layers',
        placement: 'MenuBar',
        name: 'Find Layers',
    },
    {
        id: 2983,
        label: 'Layer > Rename Layer...',
        placement: 'MenuBar',
        name: 'Rename Layer...',
    },
    {
        id: 2986,
        label: 'Select > Isolate Layers',
        placement: 'MenuBar',
        name: 'Isolate Layers',
    },
    {
        id: 2991,
        label: 'Image > Image Rotation > 90° Clockwise',
        placement: 'MenuBar',
        name: '90° Clockwise',
    },
    {
        id: 2992,
        label: 'Image > Image Rotation > 90° Counter Clockwise',
        placement: 'MenuBar',
        name: '90° Counter Clockwise',
    },
    {
        id: 2993,
        label: 'Image > Image Rotation > 180°',
        placement: 'MenuBar',
        name: '180°',
    },
    {
        id: 2994,
        label: 'Image > Image Rotation > Arbitrary...',
        placement: 'MenuBar',
        name: 'Arbitrary...',
    },
    {
        id: 2996,
        label: 'Image > Image Rotation > Flip Canvas Horizontal',
        placement: 'MenuBar',
        name: 'Flip Canvas Horizontal',
    },
    {
        id: 2997,
        label: 'Image > Image Rotation > Flip Canvas Vertical',
        placement: 'MenuBar',
        name: 'Flip Canvas Vertical',
    },
    {
        id: 3056,
        label: 'Image > Adjustments > Channel Mixer...',
        placement: 'MenuBar',
        name: 'Channel Mixer...',
    },
    {
        id: 3062,
        label: 'Image > Adjustments > Gradient Map...',
        placement: 'MenuBar',
        name: 'Gradient Map...',
    },
    {
        id: 3063,
        label: 'Image > Adjustments > Photo Filter...',
        placement: 'MenuBar',
        name: 'Photo Filter...',
    },
    {
        id: 3065,
        label: 'Image > Adjustments > Shadows/Highlights...',
        placement: 'MenuBar',
        name: 'Shadows/Highlights...',
    },
    {
        id: 3066,
        label: 'Image > Adjustments > Color Lookup...',
        placement: 'MenuBar',
        name: 'Color Lookup...',
    },
    {
        id: 3067,
        label: 'Image > Adjustments > Exposure...',
        placement: 'MenuBar',
        name: 'Exposure...',
    },
    {
        id: 3076,
        label: 'Layer > Smart Filter > Disable Filter Mask',
        placement: 'MenuBar',
        name: 'Disable Filter Mask',
    },
    {
        id: 3083,
        label: 'Layer > New Adjustment Layer > Exposure...',
        placement: 'MenuBar',
        name: 'Exposure...',
    },
    {
        id: 3085,
        label: 'Layer > New Adjustment Layer > Color and vibrance...',
        placement: 'MenuBar',
        name: 'Color and vibrance...',
    },
    {
        id: 3090,
        label: 'File > Place Linked...',
        placement: 'MenuBar',
        name: 'Place Linked...',
    },
    {
        id: 3091,
        label: 'Layer > Smart Objects > Reveal in Finder',
        placement: 'MenuBar',
        name: 'Reveal in Finder',
    },
    {
        id: 3092,
        label: 'File > Package...',
        placement: 'MenuBar',
        name: 'Package...',
    },
    {
        id: 3098,
        label: 'File > Automate > Generator Plugins',
        placement: 'MenuBar',
        name: 'Generator Plugins',
    },
    {
        id: 3187,
        label: 'Window > Styles',
        placement: 'MenuBar',
        name: 'Styles',
    },
    {
        id: 3300,
        label: 'Type > Panels > Character Panel',
        placement: 'MenuBar',
        name: 'Character Panel',
    },
    {
        id: 3300,
        label: 'Window > Character',
        placement: 'MenuBar',
        name: 'Character',
    },
    {
        id: 3309,
        label: 'Type > OpenType > Standard Ligatures',
        placement: 'MenuBar',
        name: 'Standard Ligatures',
    },
    {
        id: 3310,
        label: 'Type > OpenType > Oldstyle',
        placement: 'MenuBar',
        name: 'Oldstyle',
    },
    {
        id: 3327,
        label: 'Type > OpenType > Proportional Metrics',
        placement: 'MenuBar',
        name: 'Proportional Metrics',
    },
    {
        id: 3334,
        label: 'Type > OpenType > Swash',
        placement: 'MenuBar',
        name: 'Swash',
    },
    {
        id: 3338,
        label: 'Type > OpenType > Contextual Alternates',
        placement: 'MenuBar',
        name: 'Contextual Alternates',
    },
    {
        id: 3339,
        label: 'Type > OpenType > Discretionary Ligatures',
        placement: 'MenuBar',
        name: 'Discretionary Ligatures',
    },
    {
        id: 3340,
        label: 'Type > OpenType > Stylistic Alternates',
        placement: 'MenuBar',
        name: 'Stylistic Alternates',
    },
    {
        id: 3341,
        label: 'Type > OpenType > Titling Alternates',
        placement: 'MenuBar',
        name: 'Titling Alternates',
    },
    {
        id: 3342,
        label: 'Type > OpenType > Ornaments',
        placement: 'MenuBar',
        name: 'Ornaments',
    },
    {
        id: 3343,
        label: 'Type > OpenType > Ordinals',
        placement: 'MenuBar',
        name: 'Ordinals',
    },
    {
        id: 3344,
        label: 'Type > OpenType > Fractions',
        placement: 'MenuBar',
        name: 'Fractions',
    },
    {
        id: 3345,
        label: 'Type > OpenType > Japanese 78',
        placement: 'MenuBar',
        name: 'Japanese 78',
    },
    {
        id: 3346,
        label: 'Type > OpenType > Japanese Expert',
        placement: 'MenuBar',
        name: 'Japanese Expert',
    },
    {
        id: 3347,
        label: 'Type > OpenType > Japanese Traditional',
        placement: 'MenuBar',
        name: 'Japanese Traditional',
    },
    {
        id: 3348,
        label: 'Type > OpenType > Kana',
        placement: 'MenuBar',
        name: 'Kana',
    },
    {
        id: 3349,
        label: 'Type > OpenType > Roman Italics',
        placement: 'MenuBar',
        name: 'Roman Italics',
    },
    {
        id: 3350,
        label: 'Type > Panels > Paragraph Panel',
        placement: 'MenuBar',
        name: 'Paragraph Panel',
    },
    {
        id: 3350,
        label: 'Window > Paragraph',
        placement: 'MenuBar',
        name: 'Paragraph',
    },
    {
        id: 3370,
        label: 'Type > Anti-Alias > None',
        placement: 'MenuBar',
        name: 'None',
    },
    {
        id: 3371,
        label: 'Type > Anti-Alias > Crisp',
        placement: 'MenuBar',
        name: 'Crisp',
    },
    {
        id: 3372,
        label: 'Type > Anti-Alias > Strong',
        placement: 'MenuBar',
        name: 'Strong',
    },
    {
        id: 3373,
        label: 'Type > Anti-Alias > Smooth',
        placement: 'MenuBar',
        name: 'Smooth',
    },
    {
        id: 3374,
        label: 'Type > Anti-Alias > Sharp',
        placement: 'MenuBar',
        name: 'Sharp',
    },
    {
        id: 3375,
        label: 'Type > Anti-Alias > Mac LCD',
        placement: 'MenuBar',
        name: 'Mac LCD',
    },
    {
        id: 3376,
        label: 'Type > Anti-Alias > Mac',
        placement: 'MenuBar',
        name: 'Mac',
    },
    {
        id: 3382,
        label: 'Type > Convert Text Shape Type',
        placement: 'MenuBar',
        name: 'Convert Text Shape Type',
    },
    {
        id: 3390,
        label: 'Type > Update All Text Layers',
        placement: 'MenuBar',
        name: 'Update All Text Layers',
    },
    {
        id: 3392,
        label: 'Edit > Check Spelling...',
        placement: 'MenuBar',
        name: 'Check Spelling...',
    },
    {
        id: 3393,
        label: 'Edit > Find and Replace Text...',
        placement: 'MenuBar',
        name: 'Find and Replace Text...',
    },
    {
        id: 3409,
        label: 'Layer > Combine Shapes > Unite Shapes',
        placement: 'MenuBar',
        name: 'Unite Shapes',
    },
    {
        id: 3410,
        label: 'Layer > Combine Shapes > Subtract Front Shape',
        placement: 'MenuBar',
        name: 'Subtract Front Shape',
    },
    {
        id: 3411,
        label: 'Layer > Combine Shapes > Unite Shapes at Overlap',
        placement: 'MenuBar',
        name: 'Unite Shapes at Overlap',
    },
    {
        id: 3412,
        label: 'Layer > Combine Shapes > Subtract Shapes at Overlap',
        placement: 'MenuBar',
        name: 'Subtract Shapes at Overlap',
    },
    {
        id: 3438,
        label: 'Layer > Copy SVG',
        placement: 'MenuBar',
        name: 'Copy SVG',
    },
    {
        id: 3439,
        label: 'Layer > Copy CSS',
        placement: 'MenuBar',
        name: 'Copy CSS',
    },
    {
        id: 3443,
        label: 'File > Export > Export As...',
        placement: 'MenuBar',
        name: 'Export As...',
    },
    {
        id: 3444,
        label: 'File > Export > Quick Export as PNG',
        placement: 'MenuBar',
        name: 'Quick Export as PNG',
    },
    {
        id: 3446,
        label: 'Layer > Quick Export as PNG',
        placement: 'MenuBar',
        name: 'Quick Export as PNG',
    },
    {
        id: 3447,
        label: 'Layer > Export As...',
        placement: 'MenuBar',
        name: 'Export As...',
    },
    {
        id: 3451,
        label: 'Type > Language Options > LTR Arabic Digits - 123%',
        placement: 'MenuBar',
        name: 'LTR Arabic Digits - 123%',
    },
    {
        id: 3452,
        label: 'Type > Language Options > Farsi Digits',
        placement: 'MenuBar',
        name: 'Farsi Digits',
    },
    {
        id: 3453,
        label: 'Type > Language Options > Hindi Digits',
        placement: 'MenuBar',
        name: 'Hindi Digits',
    },
    {
        id: 3459,
        label: 'Type > Language Options > RTL Arabic Digits - %123',
        placement: 'MenuBar',
        name: 'RTL Arabic Digits - %123',
    },
    {
        id: 3500,
        label: 'View > Extras',
        placement: 'MenuBar',
        name: 'Extras',
    },
    {
        id: 3501,
        label: 'View > Show > Selection Edges',
        placement: 'MenuBar',
        name: 'Selection Edges',
    },
    {
        id: 3502,
        label: 'View > Show > Target Path',
        placement: 'MenuBar',
        name: 'Target Path',
    },
    {
        id: 3503,
        label: 'View > Show > Guides',
        placement: 'MenuBar',
        name: 'Guides',
    },
    {
        id: 3504,
        label: 'View > Show > Grid',
        placement: 'MenuBar',
        name: 'Grid',
    },
    {
        id: 3505,
        label: 'View > Show > Slices',
        placement: 'MenuBar',
        name: 'Slices',
    },
    {
        id: 3506,
        label: 'View > Show > Notes',
        placement: 'MenuBar',
        name: 'Notes',
    },
    {
        id: 3507,
        label: 'View > Show > All',
        placement: 'MenuBar',
        name: 'All',
    },
    {
        id: 3508,
        label: 'View > Show > None',
        placement: 'MenuBar',
        name: 'None',
    },
    {
        id: 3510,
        label: 'View > Show > Show Extras Options...',
        placement: 'MenuBar',
        name: 'Show Extras Options...',
    },
    {
        id: 3511,
        label: 'View > Show > Smart Guides',
        placement: 'MenuBar',
        name: 'Smart Guides',
    },
    {
        id: 3512,
        label: 'View > Show > Layer Edges',
        placement: 'MenuBar',
        name: 'Layer Edges',
    },
    {
        id: 3513,
        label: 'View > Show > Count',
        placement: 'MenuBar',
        name: 'Count',
    },
    {
        id: 3514,
        label: 'View > Show > Pixel Grid',
        placement: 'MenuBar',
        name: 'Pixel Grid',
    },
    {
        id: 3517,
        label: 'View > Show > Mesh',
        placement: 'MenuBar',
        name: 'Mesh',
    },
    {
        id: 3520,
        label: 'View > Snap',
        placement: 'MenuBar',
        name: 'Snap',
    },
    {
        id: 3521,
        label: 'View > Snap To > Guides',
        placement: 'MenuBar',
        name: 'Guides',
    },
    {
        id: 3522,
        label: 'View > Snap To > Grid',
        placement: 'MenuBar',
        name: 'Grid',
    },
    {
        id: 3523,
        label: 'View > Snap To > Slices',
        placement: 'MenuBar',
        name: 'Slices',
    },
    {
        id: 3524,
        label: 'View > Snap To > Document Bounds',
        placement: 'MenuBar',
        name: 'Document Bounds',
    },
    {
        id: 3527,
        label: 'View > Snap To > All',
        placement: 'MenuBar',
        name: 'All',
    },
    {
        id: 3528,
        label: 'View > Snap To > None',
        placement: 'MenuBar',
        name: 'None',
    },
    {
        id: 3530,
        label: 'View > Snap To > Layers',
        placement: 'MenuBar',
        name: 'Layers',
    },
    {
        id: 3532,
        label: 'View > Show > Pattern Preview Tile Bounds',
        placement: 'MenuBar',
        name: 'Pattern Preview Tile Bounds',
    },
    {
        id: 3533,
        label: 'View > Show > Artboard Guides',
        placement: 'MenuBar',
        name: 'Artboard Guides',
    },
    {
        id: 3535,
        label: 'View > Show > Artboard Names',
        placement: 'MenuBar',
        name: 'Artboard Names',
    },
    {
        id: 3536,
        label: 'View > Show > Canvas Guides',
        placement: 'MenuBar',
        name: 'Canvas Guides',
    },
    {
        id: 3541,
        label: 'Layer > Rasterize > Shape',
        placement: 'MenuBar',
        name: 'Shape',
    },
    {
        id: 3542,
        label: 'Layer > Rasterize > Type',
        placement: 'MenuBar',
        name: 'Type',
    },
    {
        id: 3542,
        label: 'Type > Rasterize Type Layer',
        placement: 'MenuBar',
        name: 'Rasterize Type Layer',
    },
    {
        id: 3544,
        label: 'Layer > Rasterize > Fill Content',
        placement: 'MenuBar',
        name: 'Fill Content',
    },
    {
        id: 3545,
        label: 'Layer > Rasterize > All Layers',
        placement: 'MenuBar',
        name: 'All Layers',
    },
    {
        id: 3547,
        label: 'Layer > Rasterize > Layer',
        placement: 'MenuBar',
        name: 'Layer',
    },
    {
        id: 3549,
        label: 'Layer > Smart Objects > Rasterize',
        placement: 'MenuBar',
        name: 'Rasterize',
    },
    {
        id: 3549,
        label: 'Layer > Rasterize > Smart Object',
        placement: 'MenuBar',
        name: 'Smart Object',
    },
    {
        id: 3551,
        label: 'Layer > Rasterize > Video',
        placement: 'MenuBar',
        name: 'Video',
    },
    {
        id: 3553,
        label: 'Layer > Rasterize > 3D',
        placement: 'MenuBar',
        name: '3D',
    },
    {
        id: 3555,
        label: 'Layer > Video Layers > Rasterize',
        placement: 'MenuBar',
        name: 'Rasterize',
    },
    {
        id: 3557,
        label: 'Layer > Rasterize > Layer Style',
        placement: 'MenuBar',
        name: 'Layer Style',
    },
    {
        id: 3561,
        label: 'Layer > Rasterize > Generative',
        placement: 'MenuBar',
        name: 'Generative',
    },
    {
        id: 3585,
        label: 'View > Show > Edit Pins',
        placement: 'MenuBar',
        name: 'Edit Pins',
    },
    {
        id: 3911,
        label: 'Filter > NextGen Filters > Blur (Gaussian)',
        placement: 'MenuBar',
        name: 'Blur (Gaussian)',
    },
    {
        id: 4002,
        label: 'Help > Updates...',
        placement: 'MenuBar',
        name: 'Updates...',
    },
    {
        id: 4210,
        label: 'Window > Tool Presets',
        placement: 'MenuBar',
        name: 'Tool Presets',
    },
    {
        id: 5059,
        label: 'Layer > Layer Mask > Delete',
        placement: 'MenuBar',
        name: 'Delete',
    },
    {
        id: 5068,
        label: 'Edit > Paste Special > Paste Outside',
        placement: 'MenuBar',
        name: 'Paste Outside',
    },
    {
        id: 5069,
        label: 'Select > Edit in Quick Mask Mode',
        placement: 'MenuBar',
        name: 'Edit in Quick Mask Mode',
    },
    {
        id: 5085,
        label: 'Layer > Layer Mask > Link',
        placement: 'MenuBar',
        name: 'Link',
    },
    {
        id: 5095,
        label: 'Layer > Layer Mask > Apply',
        placement: 'MenuBar',
        name: 'Apply',
    },
    {
        id: 5115,
        label: 'Window > Workspace > New Workspace...',
        placement: 'MenuBar',
        name: 'New Workspace...',
    },
    {
        id: 5116,
        label: 'Window > Workspace > Delete Workspace...',
        placement: 'MenuBar',
        name: 'Delete Workspace...',
    },
    {
        id: 5117,
        label: 'Window > Workspace > Reset Essentials',
        placement: 'MenuBar',
        name: 'Reset Essentials',
    },
    {
        id: 5217,
        label: 'Layer > New Layer Based Slice',
        placement: 'MenuBar',
        name: 'New Layer Based Slice',
    },
    {
        id: 5226,
        label: 'Layer > Smart Filter > Delete Filter Mask',
        placement: 'MenuBar',
        name: 'Delete Filter Mask',
    },
    {
        id: 5613,
        label: 'View > Guides > New Guide...',
        placement: 'MenuBar',
        name: 'New Guide...',
    },
    {
        id: 5614,
        label: 'View > Guides > New Guide Layout...',
        placement: 'MenuBar',
        name: 'New Guide Layout...',
    },
    {
        id: 5615,
        label: 'View > Guides > New Guides From Shape',
        placement: 'MenuBar',
        name: 'New Guides From Shape',
    },
    {
        id: 5624,
        label: 'Edit > Define Custom Shape...',
        placement: 'MenuBar',
        name: 'Define Custom Shape...',
    },
    {
        id: 5634,
        label: 'Window > Workspace > Essentials (Default)',
        placement: 'MenuBar',
        name: 'Essentials (Default)',
    },
    {
        id: 5929,
        label: 'Window > Arrange > Bring All to Front',
        placement: 'MenuBar',
        name: 'Bring All to Front',
    },
    {
        id: 5930,
        label: 'Window > Arrange > Cascade',
        placement: 'MenuBar',
        name: 'Cascade',
    },
    {
        id: 5931,
        label: 'Window > Arrange > Tile',
        placement: 'MenuBar',
        name: 'Tile',
    },
    {
        id: 5932,
        label: 'Window > Arrange > Minimize',
        placement: 'MenuBar',
        name: 'Minimize',
    },
    {
        id: 5933,
        label: 'Window > Arrange > Tile All Vertically',
        placement: 'MenuBar',
        name: 'Tile All Vertically',
    },
    {
        id: 5934,
        label: 'Window > Arrange > Tile All Horizontally',
        placement: 'MenuBar',
        name: 'Tile All Horizontally',
    },
    {
        id: 5935,
        label: 'Window > Arrange > 2-up Horizontal',
        placement: 'MenuBar',
        name: '2-up Horizontal',
    },
    {
        id: 5936,
        label: 'Window > Arrange > 2-up Vertical',
        placement: 'MenuBar',
        name: '2-up Vertical',
    },
    {
        id: 5937,
        label: 'Window > Arrange > 3-up Horizontal',
        placement: 'MenuBar',
        name: '3-up Horizontal',
    },
    {
        id: 5938,
        label: 'Window > Arrange > 3-up Vertical',
        placement: 'MenuBar',
        name: '3-up Vertical',
    },
    {
        id: 5939,
        label: 'Window > Arrange > 3-up Stacked',
        placement: 'MenuBar',
        name: '3-up Stacked',
    },
    {
        id: 5940,
        label: 'Window > Arrange > 4-up',
        placement: 'MenuBar',
        name: '4-up',
    },
    {
        id: 5941,
        label: 'Window > Arrange > 6-up',
        placement: 'MenuBar',
        name: '6-up',
    },
    {
        id: 5956,
        label: 'Help > Photoshop Help...',
        placement: 'MenuBar',
        name: 'Photoshop Help...',
    },
    {
        id: 5957,
        label: 'Edit > Search',
        placement: 'MenuBar',
        name: 'Search',
    },
    {
        id: 5960,
        label: 'Window > Arrange > Match Zoom',
        placement: 'MenuBar',
        name: 'Match Zoom',
    },
    {
        id: 5962,
        label: 'Window > Arrange > Match Location',
        placement: 'MenuBar',
        name: 'Match Location',
    },
    {
        id: 5963,
        label: 'Window > Arrange > Match Rotation',
        placement: 'MenuBar',
        name: 'Match Rotation',
    },
    {
        id: 5964,
        label: 'Window > Arrange > Match All',
        placement: 'MenuBar',
        name: 'Match All',
    },
    {
        id: 5966,
        label: 'File > Share for Review',
        placement: 'MenuBar',
        name: 'Share for Review',
    },
    {
        id: 5967,
        label: 'File > Invite to Edit...',
        placement: 'MenuBar',
        name: 'Invite to Edit...',
    },
    {
        id: 5968,
        label: 'File > Export > Send to Firefly Boards',
        placement: 'MenuBar',
        name: 'Send to Firefly Boards',
    },
    {
        id: 5980,
        label: 'Edit > Keyboard Shortcuts...',
        placement: 'MenuBar',
        name: 'Keyboard Shortcuts...',
    },
    {
        id: 5981,
        label: 'Window > Workspace > Keyboard Shortcuts & Menus...',
        placement: 'MenuBar',
        name: 'Keyboard Shortcuts & Menus...',
    },
    {
        id: 5982,
        label: 'Edit > Menus...',
        placement: 'MenuBar',
        name: 'Menus...',
    },
    {
        id: 5983,
        label: 'Edit > Toolbar...',
        placement: 'MenuBar',
        name: 'Toolbar...',
    },
    {
        id: 5991,
        label: 'View > Screen Mode > Standard Screen Mode',
        placement: 'MenuBar',
        name: 'Standard Screen Mode',
    },
    {
        id: 5992,
        label: 'View > Screen Mode > Full Screen Mode With Menu Bar',
        placement: 'MenuBar',
        name: 'Full Screen Mode With Menu Bar',
    },
    {
        id: 5993,
        label: 'View > Screen Mode > Full Screen Mode',
        placement: 'MenuBar',
        name: 'Full Screen Mode',
    },
    {
        id: 5996,
        label: 'Window > Arrange > Float in Window',
        placement: 'MenuBar',
        name: 'Float in Window',
    },
    {
        id: 5997,
        label: 'Window > Arrange > Float All in Windows',
        placement: 'MenuBar',
        name: 'Float All in Windows',
    },
    {
        id: 5998,
        label: 'Window > Arrange > Consolidate All to Tabs',
        placement: 'MenuBar',
        name: 'Consolidate All to Tabs',
    },
    {
        id: 6300,
        label: 'Layer > New Fill Layer > Solid Color...',
        placement: 'MenuBar',
        name: 'Solid Color...',
    },
    {
        id: 6301,
        label: 'Layer > New Fill Layer > Gradient...',
        placement: 'MenuBar',
        name: 'Gradient...',
    },
    {
        id: 6302,
        label: 'Layer > New Fill Layer > Pattern...',
        placement: 'MenuBar',
        name: 'Pattern...',
    },
    {
        id: 6303,
        label: 'Layer > New Adjustment Layer > Levels...',
        placement: 'MenuBar',
        name: 'Levels...',
    },
    {
        id: 6304,
        label: 'Layer > New Adjustment Layer > Curves...',
        placement: 'MenuBar',
        name: 'Curves...',
    },
    {
        id: 6305,
        label: 'Layer > New Adjustment Layer > Color Balance...',
        placement: 'MenuBar',
        name: 'Color Balance...',
    },
    {
        id: 6306,
        label: 'Layer > New Adjustment Layer > Brightness/Contrast...',
        placement: 'MenuBar',
        name: 'Brightness/Contrast...',
    },
    {
        id: 6308,
        label: 'Layer > New Adjustment Layer > Hue/Saturation...',
        placement: 'MenuBar',
        name: 'Hue/Saturation...',
    },
    {
        id: 6309,
        label: 'Layer > New Adjustment Layer > Selective Color...',
        placement: 'MenuBar',
        name: 'Selective Color...',
    },
    {
        id: 6310,
        label: 'Layer > New Adjustment Layer > Channel Mixer...',
        placement: 'MenuBar',
        name: 'Channel Mixer...',
    },
    {
        id: 6311,
        label: 'Layer > New Adjustment Layer > Gradient Map...',
        placement: 'MenuBar',
        name: 'Gradient Map...',
    },
    {
        id: 6312,
        label: 'Layer > New Adjustment Layer > Photo Filter...',
        placement: 'MenuBar',
        name: 'Photo Filter...',
    },
    {
        id: 6313,
        label: 'Layer > New Adjustment Layer > Invert...',
        placement: 'MenuBar',
        name: 'Invert...',
    },
    {
        id: 6314,
        label: 'Layer > New Adjustment Layer > Threshold...',
        placement: 'MenuBar',
        name: 'Threshold...',
    },
    {
        id: 6315,
        label: 'Layer > New Adjustment Layer > Posterize...',
        placement: 'MenuBar',
        name: 'Posterize...',
    },
    {
        id: 6332,
        label: 'Layer > Smart Objects > Edit Contents',
        placement: 'MenuBar',
        name: 'Edit Contents',
    },
    {
        id: 6333,
        label: 'Layer > Smart Objects > Replace Contents...',
        placement: 'MenuBar',
        name: 'Replace Contents...',
    },
    {
        id: 6334,
        label: 'Layer > Smart Objects > Export Contents...',
        placement: 'MenuBar',
        name: 'Export Contents...',
    },
    {
        id: 6337,
        label: 'Layer > New Adjustment Layer > Color Lookup...',
        placement: 'MenuBar',
        name: 'Color Lookup...',
    },
    {
        id: 6339,
        label: 'Layer > Smart Objects > Convert to Linked...',
        placement: 'MenuBar',
        name: 'Convert to Linked...',
    },
    {
        id: 6340,
        label: 'Layer > Smart Objects > Relink to File...',
        placement: 'MenuBar',
        name: 'Relink to File...',
    },
    {
        id: 6341,
        label: 'Layer > Smart Objects > Relink to Library Graphic...',
        placement: 'MenuBar',
        name: 'Relink to Library Graphic...',
    },
    {
        id: 6342,
        label: 'Layer > Smart Objects > Update Modified Content',
        placement: 'MenuBar',
        name: 'Update Modified Content',
    },
    {
        id: 6343,
        label: 'Layer > Smart Objects > Update All Modified Content',
        placement: 'MenuBar',
        name: 'Update All Modified Content',
    },
    {
        id: 6345,
        label: 'Layer > Smart Objects > Embed Linked',
        placement: 'MenuBar',
        name: 'Embed Linked',
    },
    {
        id: 6346,
        label: 'Layer > Smart Objects > Embed All Linked',
        placement: 'MenuBar',
        name: 'Embed All Linked',
    },
    {
        id: 6347,
        label: 'Layer > Smart Objects > Reset Transform',
        placement: 'MenuBar',
        name: 'Reset Transform',
    },
    {
        id: 6348,
        label: 'Layer > New Adjustment Layer > Black & White...',
        placement: 'MenuBar',
        name: 'Black & White...',
    },
    {
        id: 6351,
        label: 'Layer > Video Layers > New Video Layer from File...',
        placement: 'MenuBar',
        name: 'New Video Layer from File...',
    },
    {
        id: 6352,
        label: 'Layer > Video Layers > New Blank Video Layer',
        placement: 'MenuBar',
        name: 'New Blank Video Layer',
    },
    {
        id: 6353,
        label: 'Layer > Video Layers > Insert Blank Frame',
        placement: 'MenuBar',
        name: 'Insert Blank Frame',
    },
    {
        id: 6354,
        label: 'Layer > Video Layers > Duplicate Frame',
        placement: 'MenuBar',
        name: 'Duplicate Frame',
    },
    {
        id: 6355,
        label: 'Layer > Video Layers > Delete Frame',
        placement: 'MenuBar',
        name: 'Delete Frame',
    },
    {
        id: 6356,
        label: 'Layer > Video Layers > Interpret Footage...',
        placement: 'MenuBar',
        name: 'Interpret Footage...',
    },
    {
        id: 6357,
        label: 'Layer > Video Layers > Replace Footage...',
        placement: 'MenuBar',
        name: 'Replace Footage...',
    },
    {
        id: 6358,
        label: 'Layer > Video Layers > Show Altered Video',
        placement: 'MenuBar',
        name: 'Show Altered Video',
    },
    {
        id: 6360,
        label: 'Layer > Video Layers > Restore Frame',
        placement: 'MenuBar',
        name: 'Restore Frame',
    },
    {
        id: 6361,
        label: 'Layer > Video Layers > Restore All Frames',
        placement: 'MenuBar',
        name: 'Restore All Frames',
    },
    {
        id: 6362,
        label: 'File > Import > Video Frames to Layers...',
        placement: 'MenuBar',
        name: 'Video Frames to Layers...',
    },
    {
        id: 6363,
        label: 'Layer > Video Layers > Reload Frame',
        placement: 'MenuBar',
        name: 'Reload Frame',
    },
    {
        id: 6400,
        label: 'View > 32-bit Preview Options...',
        placement: 'MenuBar',
        name: '32-bit Preview Options...',
    },
    {
        id: 6432,
        label: 'Layer > Smart Objects > Stack Mode > None',
        placement: 'MenuBar',
        name: 'None',
    },
    {
        id: 6440,
        label: 'Filter > Convert for Smart Filters',
        placement: 'MenuBar',
        name: 'Convert for Smart Filters',
    },
    {
        id: 6478,
        label: 'Window > Properties',
        placement: 'MenuBar',
        name: 'Properties',
    },
    {
        id: 6479,
        label: 'Window > Adjustments',
        placement: 'MenuBar',
        name: 'Adjustments',
    },
    {
        id: 6651,
        label: 'Layer > New Adjustment Layer > Clarity and dehaze...',
        placement: 'MenuBar',
        name: 'Clarity and dehaze...',
    },
    {
        id: 6652,
        label: 'Layer > New Adjustment Layer > Grain...',
        placement: 'MenuBar',
        name: 'Grain...',
    },
    {
        id: 7763,
        label: 'Window > Gradients',
        placement: 'MenuBar',
        name: 'Gradients',
    },
    {
        id: 7767,
        label: 'Window > Patterns',
        placement: 'MenuBar',
        name: 'Patterns',
    },
    {
        id: 7772,
        label: 'Window > Shapes',
        placement: 'MenuBar',
        name: 'Shapes',
    },
    {
        id: 7785,
        label: 'Window > Content Credentials (Beta)',
        placement: 'MenuBar',
        name: 'Content Credentials (Beta)',
    },
    {
        id: 7788,
        label: 'Window > Materials',
        placement: 'MenuBar',
        name: 'Materials',
    },
    {
        id: 7789,
        label: 'Filter > Parametric Filters...',
        placement: 'MenuBar',
        name: 'Parametric Filters...',
    },
    {
        id: 7800,
        label: 'Image > Apply Data Set...',
        placement: 'MenuBar',
        name: 'Apply Data Set...',
    },
    {
        id: 7802,
        label: 'Image > Variables > Define...',
        placement: 'MenuBar',
        name: 'Define...',
    },
    {
        id: 7803,
        label: 'Image > Variables > Data Sets...',
        placement: 'MenuBar',
        name: 'Data Sets...',
    },
    {
        id: 7805,
        label: 'File > Import > Variable Data Sets...',
        placement: 'MenuBar',
        name: 'Variable Data Sets...',
    },
    {
        id: 7806,
        label: 'File > Export > Data Sets as Files...',
        placement: 'MenuBar',
        name: 'Data Sets as Files...',
    },
    {
        id: 7900,
        label: 'Image > Analysis > Count Tool',
        placement: 'MenuBar',
        name: 'Count Tool',
    },
    {
        id: 7930,
        label: 'Window > Application Frame',
        placement: 'MenuBar',
        name: 'Application Frame',
    },
    {
        id: 8820,
        label: 'Filter > Neural Filters...',
        placement: 'MenuBar',
        name: 'Neural Filters...',
    },
    {
        id: 9066,
        label: 'Type > Panels > Character Styles Panel',
        placement: 'MenuBar',
        name: 'Character Styles Panel',
    },
    {
        id: 9066,
        label: 'Window > Character Styles',
        placement: 'MenuBar',
        name: 'Character Styles',
    },
    {
        id: 9067,
        label: 'Type > Panels > Paragraph Styles Panel',
        placement: 'MenuBar',
        name: 'Paragraph Styles Panel',
    },
    {
        id: 9067,
        label: 'Window > Paragraph Styles',
        placement: 'MenuBar',
        name: 'Paragraph Styles',
    },
    {
        id: 9068,
        label: 'Type > Panels > Glyphs Panel',
        placement: 'MenuBar',
        name: 'Glyphs Panel',
    },
    {
        id: 9068,
        label: 'Window > Glyphs',
        placement: 'MenuBar',
        name: 'Glyphs',
    },
    {
        id: 9086,
        label: 'Type > OpenType > Justification Alternates',
        placement: 'MenuBar',
        name: 'Justification Alternates',
    },
    {
        id: 9087,
        label: 'Type > Manage Missing Fonts',
        placement: 'MenuBar',
        name: 'Manage Missing Fonts',
    },
    {
        id: 9100,
        label: 'Type > Language Options > Default Features',
        placement: 'MenuBar',
        name: 'Default Features',
    },
    {
        id: 9101,
        label: 'Type > Language Options > East Asian Features',
        placement: 'MenuBar',
        name: 'East Asian Features',
    },
    {
        id: 9102,
        label: 'Type > Language Options > Middle Eastern Features',
        placement: 'MenuBar',
        name: 'Middle Eastern Features',
    },
    {
        id: 9109,
        label: 'Type > Font Preview Size > None',
        placement: 'MenuBar',
        name: 'None',
    },
    {
        id: 9110,
        label: 'Type > Font Preview Size > Small',
        placement: 'MenuBar',
        name: 'Small',
    },
    {
        id: 9111,
        label: 'Type > Font Preview Size > Medium',
        placement: 'MenuBar',
        name: 'Medium',
    },
    {
        id: 9112,
        label: 'Type > Font Preview Size > Large',
        placement: 'MenuBar',
        name: 'Large',
    },
    {
        id: 9113,
        label: 'Type > Font Preview Size > Extra Large',
        placement: 'MenuBar',
        name: 'Extra Large',
    },
    {
        id: 9114,
        label: 'Type > Font Preview Size > Huge',
        placement: 'MenuBar',
        name: 'Huge',
    },
    {
        id: 9119,
        label: 'Type > Paste Lorem Ipsum',
        placement: 'MenuBar',
        name: 'Paste Lorem Ipsum',
    },
    {
        id: 9121,
        label: 'Type > Load Default Type Styles',
        placement: 'MenuBar',
        name: 'Load Default Type Styles',
    },
    {
        id: 9122,
        label: 'Type > Save Default Type Styles',
        placement: 'MenuBar',
        name: 'Save Default Type Styles',
    },
    {
        id: 9123,
        label: 'Type > Match Font...',
        placement: 'MenuBar',
        name: 'Match Font...',
    },
    {
        id: 9130,
        label: 'Type > Language Options > Standard Vertical Roman Alignment',
        placement: 'MenuBar',
        name: 'Standard Vertical Roman Alignment',
    },
    {
        id: 9131,
        label: 'Type > Language Options > Tate-chu-yoko',
        placement: 'MenuBar',
        name: 'Tate-chu-yoko',
    },
    {
        id: 9132,
        label: 'Type > Language Options > Top-to-Top Leading',
        placement: 'MenuBar',
        name: 'Top-to-Top Leading',
    },
    {
        id: 9133,
        label: 'Type > Language Options > Bottom-to-Bottom Leading',
        placement: 'MenuBar',
        name: 'Bottom-to-Bottom Leading',
    },
    {
        id: 9137,
        label: 'Type > Language Options > Kashidas',
        placement: 'MenuBar',
        name: 'Kashidas',
    },
    {
        id: 9138,
        label: 'Type > Language Options > Default Direction',
        placement: 'MenuBar',
        name: 'Default Direction',
    },
    {
        id: 9139,
        label: 'Type > Language Options > Left-to-Right Character Direction',
        placement: 'MenuBar',
        name: 'Left-to-Right Character Direction',
    },
    {
        id: 9140,
        label: 'Type > Language Options > Right-to-Left Character Direction',
        placement: 'MenuBar',
        name: 'Right-to-Left Character Direction',
    },
    {
        id: 9143,
        label: 'Edit > Paste Special > Paste without Formatting',
        placement: 'MenuBar',
        name: 'Paste without Formatting',
    },
    {
        id: 9220,
        label: 'Layer > New > Artboard...',
        placement: 'MenuBar',
        name: 'Artboard...',
    },
    {
        id: 9221,
        label: 'Layer > New > Artboard from Group',
        placement: 'MenuBar',
        name: 'Artboard from Group',
    },
    {
        id: 9222,
        label: 'Layer > New > Artboard from Layers...',
        placement: 'MenuBar',
        name: 'Artboard from Layers...',
    },
    {
        id: 9252,
        label: 'Layer > New > Frame from Layers...',
        placement: 'MenuBar',
        name: 'Frame from Layers...',
    },
    {
        id: 9255,
        label: 'Layer > New > Convert to Frame',
        placement: 'MenuBar',
        name: 'Convert to Frame',
    },
    {
        id: 9600,
        label: 'Window > Contextual Task Bar',
        placement: 'MenuBar',
        name: 'Contextual Task Bar',
    },
    {
        id: 11600,
        label: 'Layer > Harmonize',
        placement: 'MenuBar',
        name: 'Harmonize',
    },
    {
        id: 15004,
        label: 'Help > System Info...',
        placement: 'MenuBar',
        name: 'System Info...',
    },
    {
        id: 15009,
        label: 'Help > GPU Compatibility...',
        placement: 'MenuBar',
        name: 'GPU Compatibility...',
    },
    {
        id: 15019,
        label: 'Help > Learn more about generative credits',
        placement: 'MenuBar',
        name: 'Learn more about generative credits',
    },
    {
        id: 15020,
        label: 'Help > Adobe generative AI user guidelines',
        placement: 'MenuBar',
        name: 'Adobe generative AI user guidelines',
    },
    {
        id: 15201,
        label: 'File > Search Adobe Stock...',
        placement: 'MenuBar',
        name: 'Search Adobe Stock...',
    },
    {
        id: 15202,
        label: 'File > Search Adobe Express Templates...',
        placement: 'MenuBar',
        name: 'Search Adobe Express Templates...',
    },
    {
        id: 15203,
        label: 'Help > Hands-on Tutorials...',
        placement: 'MenuBar',
        name: 'Hands-on Tutorials...',
    },
    {
        id: 15204,
        label: "Help > What's New...",
        placement: 'MenuBar',
        name: "What's New...",
    },
    {
        id: 17001,
        label: 'Edit > Perspective Warp',
        placement: 'MenuBar',
        name: 'Perspective Warp',
    },
    {
        id: 20006,
        label: 'File > Version History',
        placement: 'MenuBar',
        name: 'Version History',
    },
    {
        id: 20007,
        label: 'Window > Version History',
        placement: 'MenuBar',
        name: 'Version History',
    },
    {
        id: 20008,
        label: 'Window > Comments',
        placement: 'MenuBar',
        name: 'Comments',
    },
    {
        id: 21000,
        label: 'Layer > Smart Objects > Convert to Layers',
        placement: 'MenuBar',
        name: 'Convert to Layers',
    },
    {
        id: 21001,
        label: 'View > Fit Layer(s) on Screen',
        placement: 'MenuBar',
        name: 'Fit Layer(s) on Screen',
    },
    {
        id: 22003,
        label: 'View > Guides > Edit Selected Guides',
        placement: 'MenuBar',
        name: 'Edit Selected Guides',
    },
    {
        id: 22004,
        label: 'View > Guides > Clear Selected Guides',
        placement: 'MenuBar',
        name: 'Clear Selected Guides',
    },
    {
        id: 22100,
        label: 'Layer > Mask All Objects',
        placement: 'MenuBar',
        name: 'Mask All Objects',
    },
    {
        id: 23150,
        label: 'Filter > Last Filter',
        placement: 'MenuBar',
        name: 'Last Filter',
    },
    {
        id: 23151,
        label: 'Filter > Last Filter',
        placement: 'MenuBar',
        name: 'Last Filter',
    },
    {
        id: 23152,
        label: 'Filter > Last Filter',
        placement: 'MenuBar',
        name: 'Last Filter',
    },
    {
        id: 23153,
        label: 'Filter > Last Filter',
        placement: 'MenuBar',
        name: 'Last Filter',
    },
    {
        id: 25070,
        label: 'Edit > Rotate Object',
        placement: 'MenuBar',
        name: 'Rotate Object',
    },
    {
        id: 26010,
        label: 'Edit > Reflection Removal...',
        placement: 'MenuBar',
        name: 'Reflection Removal...',
    },
    {
        id: 30900,
        label: 'File > Place Free Adobe Stock Images...',
        placement: 'MenuBar',
        name: 'Place Free Adobe Stock Images...',
    },
    {
        id: 'paintbrushTool',
        label: 'Brush Tool',
        placement: 'Tool',
    },
    {
        id: 'adjustmentBrushTool',
        label: 'Adjustment Brush Tool',
        placement: 'Tool',
    },
    {
        id: 'pencilTool',
        label: 'Pencil Tool',
        placement: 'Tool',
    },
    {
        id: 'colorReplacementBrushTool',
        label: 'Color Replacement Tool',
        placement: 'Tool',
    },
    {
        id: 'wetBrushTool',
        label: 'Mixer Brush Tool',
        placement: 'Tool',
    },
    {
        id: 'eraserTool',
        label: 'Eraser Tool',
        placement: 'Tool',
    },
    {
        id: 'backgroundEraserTool',
        label: 'Background Eraser Tool',
        placement: 'Tool',
    },
    {
        id: 'cloneStampTool',
        label: 'Clone Stamp Tool',
        placement: 'Tool',
    },
    {
        id: 'patternStampTool',
        label: 'Pattern Stamp Tool',
        placement: 'Tool',
    },
    {
        id: 'magicStampTool',
        label: 'Healing Brush Tool',
        placement: 'Tool',
    },
    {
        id: 'historyBrushTool',
        label: 'History Brush Tool',
        placement: 'Tool',
    },
    {
        id: 'artBrushTool',
        label: 'Art History Brush Tool',
        placement: 'Tool',
    },
    {
        id: 'smudgeTool',
        label: 'Smudge Tool',
        placement: 'Tool',
    },
    {
        id: 'blurTool',
        label: 'Blur Tool',
        placement: 'Tool',
    },
    {
        id: 'sharpenTool',
        label: 'Sharpen Tool',
        placement: 'Tool',
    },
    {
        id: 'dodgeTool',
        label: 'Dodge Tool',
        placement: 'Tool',
    },
    {
        id: 'burnInTool',
        label: 'Burn Tool',
        placement: 'Tool',
    },
    {
        id: 'saturationTool',
        label: 'Sponge Tool',
        placement: 'Tool',
    },
    {
        id: 'redEyeTool',
        label: 'Red Eye Tool',
        placement: 'Tool',
    },
    {
        id: 'marqueeRectTool',
        label: 'Rectangular Marquee Tool',
        placement: 'Tool',
    },
    {
        id: 'marqueeEllipTool',
        label: 'Elliptical Marquee Tool',
        placement: 'Tool',
    },
    {
        id: 'marqueeSingleRowTool',
        label: 'Single Row Marquee Tool',
        placement: 'Tool',
    },
    {
        id: 'marqueeSingleColumnTool',
        label: 'Single Column Marquee Tool',
        placement: 'Tool',
    },
    {
        id: 'moveTool',
        label: 'Move Tool',
        placement: 'Tool',
    },
    {
        id: 'artboardTool',
        label: 'Artboard Tool',
        placement: 'Tool',
    },
    {
        id: 'lassoTool',
        label: 'Lasso Tool',
        placement: 'Tool',
    },
    {
        id: 'selectionBrushTool',
        label: 'Selection Brush Tool',
        placement: 'Tool',
    },
    {
        id: 'magicLassoTool',
        label: 'Object Selection Tool',
        placement: 'Tool',
    },
    {
        id: 'polySelTool',
        label: 'Polygonal Lasso Tool',
        placement: 'Tool',
    },
    {
        id: 'magneticLassoTool',
        label: 'Magnetic Lasso Tool',
        placement: 'Tool',
    },
    {
        id: 'magicWandTool',
        label: 'Magic Wand Tool',
        placement: 'Tool',
    },
    {
        id: 'quickSelectTool',
        label: 'Quick Selection Tool',
        placement: 'Tool',
    },
    {
        id: 'cropTool',
        label: 'Crop Tool',
        placement: 'Tool',
    },
    {
        id: 'perspectiveCropTool',
        label: 'Perspective Crop Tool',
        placement: 'Tool',
    },
    {
        id: 'sliceTool',
        label: 'Slice Tool',
        placement: 'Tool',
    },
    {
        id: 'sliceSelectTool',
        label: 'Slice Select Tool',
        placement: 'Tool',
    },
    {
        id: 'magicEraserTool',
        label: 'Magic Eraser Tool',
        placement: 'Tool',
    },
    {
        id: 'gradientTool',
        label: 'Gradient Tool',
        placement: 'Tool',
    },
    {
        id: 'bucketTool',
        label: 'Paint Bucket Tool',
        placement: 'Tool',
    },
    {
        id: 'pathComponentSelectTool',
        label: 'Path Selection Tool',
        placement: 'Tool',
    },
    {
        id: 'directSelectTool',
        label: 'Direct Selection Tool',
        placement: 'Tool',
    },
    {
        id: 'penTool',
        label: 'Pen Tool',
        placement: 'Tool',
    },
    {
        id: 'freeformPenTool',
        label: 'Freeform Pen Tool',
        placement: 'Tool',
    },
    {
        id: 'curvaturePenTool',
        label: 'Curvature Pen Tool',
        placement: 'Tool',
    },
    {
        id: 'addKnotTool',
        label: 'Add Anchor Point Tool',
        placement: 'Tool',
    },
    {
        id: 'deleteKnotTool',
        label: 'Delete Anchor Point Tool',
        placement: 'Tool',
    },
    {
        id: 'convertKnotTool',
        label: 'Convert Point Tool',
        placement: 'Tool',
    },
    {
        id: 'typeCreateOrEditTool',
        label: 'Horizontal Type Tool',
        placement: 'Tool',
    },
    {
        id: 'typeVerticalCreateOrEditTool',
        label: 'Vertical Type Tool',
        placement: 'Tool',
    },
    {
        id: 'typeCreateMaskTool',
        label: 'Horizontal Type Mask Tool',
        placement: 'Tool',
    },
    {
        id: 'typeVerticalCreateMaskTool',
        label: 'Vertical Type Mask Tool',
        placement: 'Tool',
    },
    {
        id: 'rectangleTool',
        label: 'Rectangle Tool',
        placement: 'Tool',
    },
    {
        id: 'ellipseTool',
        label: 'Ellipse Tool',
        placement: 'Tool',
    },
    {
        id: 'triangleTool',
        label: 'Triangle Tool',
        placement: 'Tool',
    },
    {
        id: 'polygonTool',
        label: 'Polygon Tool',
        placement: 'Tool',
    },
    {
        id: 'lineTool',
        label: 'Line Tool',
        placement: 'Tool',
    },
    {
        id: 'customShapeTool',
        label: 'Custom Shape Tool',
        placement: 'Tool',
    },
    {
        id: 'StarTool',
        label: 'Star Tool',
        placement: 'Tool',
    },
    {
        id: 'framedGroupTool',
        label: 'Frame Tool',
        placement: 'Tool',
    },
    {
        id: 'eyedropperTool',
        label: 'Eyedropper Tool',
        placement: 'Tool',
    },
    {
        id: 'colorSamplerTool',
        label: 'Color Sampler Tool',
        placement: 'Tool',
    },
    {
        id: 'rulerTool',
        label: 'Ruler Tool',
        placement: 'Tool',
    },
    {
        id: 'textAnnotTool',
        label: 'Note Tool',
        placement: 'Tool',
    },
    {
        id: 'handTool',
        label: 'Hand Tool',
        placement: 'Tool',
    },
    {
        id: 'rotateTool',
        label: 'Rotate View Tool',
        placement: 'Tool',
    },
    {
        id: 'zoomTool',
        label: 'Zoom Tool',
        placement: 'Tool',
    },
    {
        id: 'patchSelection',
        label: 'Patch Tool',
        placement: 'Tool',
    },
    {
        id: 'recomposeSelection',
        label: 'Content-Aware Move Tool',
        placement: 'Tool',
    },
    {
        id: 'spotHealingBrushTool',
        label: 'Spot Healing Brush Tool',
        placement: 'Tool',
    },
    {
        id: 'removeTool',
        label: 'Remove Tool',
        placement: 'Tool',
    },
    {
        id: 'editToolbar',
        label: 'Edit Toolbar...',
        placement: 'Tool',
    },
    {
        id: 'countTool',
        label: 'Count Tool',
        placement: 'Tool',
    },
    {
        id: 'panelid.static.actions',
        label: 'Actions',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.gradients',
        label: 'Gradients',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.styles',
        label: 'Styles',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.swatches',
        label: 'Swatches',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.patterns',
        label: 'Patterns',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.histogram',
        label: 'Histogram',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.info',
        label: 'Info',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.paths',
        label: 'Paths',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.customshapes',
        label: 'Shapes',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.toolpresets',
        label: 'Tool Presets',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.picker',
        label: 'Color',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.channels',
        label: 'Channels',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.layers',
        label: 'Layers',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.comps',
        label: 'Layer Comps',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.animation',
        label: 'Timeline',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.clonesource',
        label: 'Clone Source',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.measurement',
        label: 'Measurement Log',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.hdrpreview',
        label: 'HDR Preview',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.history',
        label: 'History',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.navigator',
        label: 'Navigator',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.textcharacter',
        label: 'Character',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.textparagraph',
        label: 'Paragraph',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.textcharstyle',
        label: 'Character Styles',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.textparastyle',
        label: 'Paragraph Styles',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.textglyphspanel',
        label: 'Glyphs',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.annotation',
        label: 'Notes',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.properties',
        label: 'Properties',
        placement: 'Panel',
    },
    {
        id: 'panelid.dynamic.uxp/com.adobe.cai.uxp/panel',
        label: 'Content Credentials (Beta)',
        placement: 'Panel',
    },
    {
        id: 'panelid.dynamic.uxp/com.adobe.cclibrariespanel/ccLibrariesPanel',
        label: 'Libraries',
        placement: 'Panel',
    },
    {
        id: 'panelid.dynamic.uxp/com.adobe.ccx.comments-webview/ccx-comments-uxp-webview',
        label: 'Comments',
        placement: 'Panel',
    },
    {
        id: 'actionId:$dytx;selectorId:context_bar',
        label: 'Context Bar : Dynamic Text',
        placement: 'Option',
    },
    {
        id: 'actionId:$dytx;selectorId:properties',
        label: 'Panel : Dynamic Text',
        placement: 'Option',
    },
    {
        id: 'actionId:$dytx;selectorId:options',
        label: 'Tool : Dynamic Text',
        placement: 'Option',
    },
];
